<section class="c-section c-section--first c-section--last c-section--open c-section--static" *ngIf="!vm.isAuthenticated">
	
	<div class="c-section__header c-text--center">
		<div>
			<a id="headerLogoMinudoc" href="javascript:void(0);" class="c-header__logo c-logo c-logo--et"
				 (click)="vm.reload($event)"></a>
			<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 25%" class="u-hidden@md-and-up">
			<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 10%" class="u-hidden@up-to-md">
			<!-- Language menu -->
			<nav class="c-nav c-nav--tab-bar" style="z-index: 99999">
				<div class="o-container">
					<div class="c-nav__menu">
						<ul class="c-nav__list">
							<!-- Language menu -->
							<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': vm.langOpen }">
								<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="vm.toggleLangMenu()">
									<i class="c-flag c-flag--{{ vm.getLocaleOption(vm.locale).icon }} c-nav__thumb" aria-hidden="true"></i>
									<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ vm.getLocaleOption(vm.locale).shortLabel }}</span>
								</a>
								<div class="c-nav__dd-menu">
									<ul class="c-nav__dd-list">
										<ng-container *ngFor="let language of vm.locales ; let $index=index">
											<li class="c-nav__dd-item" *ngIf="language.locale !== vm.locale" (click)="vm.setLocale(language.locale)">
												<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link" >
													<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
													<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
												</a>
											</li>
										</ng-container>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
		<h1 class="c-section__title c-header__title c-section__title--sm c-text--lg c-text--center">{{ "Benu.Login_Landing_Page.Title" | translateUnauthenticated }}</h1>
	</div>
	<div class="c-section__content">
		<div class="c-card">
			<div class="c-content c-content--xxl u-osb-xxl@up-to-md">
				<p class="c-text c-text--center@md-and-up">{{ "Benu.Login_Landing_Page.Disclaimer1" | translateUnauthenticated }}</p>
				<p class="c-text c-text--center@md-and-up u-osb-xl">{{ "Benu.Login_Landing_Page.Disclaimer2" | translateUnauthenticated }}</p>
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-1.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle1' | translateUnauthenticated }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">1. {{ "Benu.Login_Landing_Page.Subtitle1" | translateUnauthenticated }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text1" | translateUnauthenticated }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-2.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle2' | translateUnauthenticated }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">2. {{ "Benu.Login_Landing_Page.Subtitle2" | translateUnauthenticated }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text2" | translateUnauthenticated }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-3.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle3' | translateUnauthenticated }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">3. {{ "Benu.Login_Landing_Page.Subtitle3" | translateUnauthenticated }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text3" | translateUnauthenticated }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-4.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle4' | translateUnauthenticated  }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">4. {{ "Benu.Login_Landing_Page.Subtitle4" | translateUnauthenticated }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text4" | translateUnauthenticated }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-5.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle5' | translateUnauthenticated }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">5. {{ "Benu.Login_Landing_Page.Subtitle5" | translateUnauthenticated }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text5" | translateUnauthenticated }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-6.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle6' | translateUnauthenticated }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">6. {{ "Benu.Login_Landing_Page.Subtitle6" | translateUnauthenticated }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text6" | translateUnauthenticated }}</p>
					</div>
				</div>
				<div class="o-grid__cell c-text--center u-ost-lg">
					<h1 class="c-section__title c-section__title--sm c-text--lg c-text c-text--center@md-and-up">
						{{ 'Benu.Login_Landing_Page.Price' | translateUnauthenticated }} {{vm.benuSetting?.price}} {{vm.benuSetting?.currency}}</h1>
				</div>
			</div>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-ost-md c-text--center u-hidden@md-and-up"
				 style="position: fixed; bottom: 49px; left: 15px; right: 15px; background-color: white; height: 80px; padding: 15px;">
			<button id="nextStepButton1" type="button" (click)="vm.redirectToNextPage()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-md u-osb-md u-ost-md">
				<span>{{ 'Benu.Prescription_Purchase_Landing_Page.Login_Forward_Button' | translateUnauthenticated }}</span>
			</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed  u-no-p u-ost-md c-text--center u-hidden@up-to-md">
			<button id="nextStepButton2" type="button" (click)="vm.redirectToNextPage()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-md u-osb-md u-osr-md">
				<span>{{ 'Benu.Prescription_Purchase_Landing_Page.Login_Forward_Button' | translateUnauthenticated }}</span>
			</button>
		</div>
	</div>
</section>


<section class="c-section c-section--first c-section--last c-section--open c-section--static" *ngIf="vm.isAuthenticated">
	<div class="c-section__header c-text--center">
		<div>
			<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 25%" class="u-hidden@md-and-up">
			<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 10%" class="u-hidden@up-to-md">
		</div>
		<h1 class="c-section__title c-header__title c-section__title--sm c-text--lg c-text--center">{{ "Benu.Login_Landing_Page.Title" | translate }}</h1>
	</div>
	<div class="c-section__content">
		<div class="c-card">
			<div class="c-content c-content--xxl u-osb-xxl@up-to-md">
				<p class="c-text c-text--center@md-and-up">{{ "Benu.Login_Landing_Page.Disclaimer1" | translate }}</p>
				<p class="c-text c-text--center@md-and-up u-osb-xl">{{ "Benu.Login_Landing_Page.Disclaimer2" | translate }}</p>
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-1.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle1' | translate }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">1. {{ "Benu.Login_Landing_Page.Subtitle1" | translate }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text1" | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-2.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle2' | translate }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">2. {{ "Benu.Login_Landing_Page.Subtitle2" | translate }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text2" | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-3.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle3' | translate }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">3. {{ "Benu.Login_Landing_Page.Subtitle3" | translate }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text3" | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-4.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle4' | translate  }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">4. {{ "Benu.Login_Landing_Page.Subtitle4" | translate }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text4" | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-5.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle5' | translate }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">5. {{ "Benu.Login_Landing_Page.Subtitle5" | translate }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text5" | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@md-and-up o-grid__cell--w-16@lg-and-up">
						<div class="o-grid o-grid--center-h u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-75 o-grid__cell--w-50@md-and-up">
								<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/instructions/step-6.svg" alt="{{ 'Benu.Login_Landing_Page.Subtitle6' | translate }}">
							</div>
						</div>
						<h2 class="c-text c-text--md c-text--center u-osb-md">6. {{ "Benu.Login_Landing_Page.Subtitle6" | translate }}</h2>
						<p class="c-text c-text--center u-osb-md">{{ "Benu.Login_Landing_Page.Text6" | translate }}</p>
					</div>
				</div>
				<div class="o-grid__cell c-text--center u-ost-lg">
					<h1 class="c-section__title c-section__title--sm c-text--lg c-text c-text--center@md-and-up">
						{{ 'Benu.Login_Landing_Page.Price' | translate }} {{vm.benuSetting?.price}} {{vm.benuSetting?.currency}}</h1>
				</div>
			</div>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p u-ost-md c-text--center u-hidden@md-and-up"
				 style="position: fixed; bottom: 49px; left: 15px; right: 15px; background-color: white; height: 80px; padding: 15px;">
			<button id="nextStepButton1" type="button" (click)="vm.redirectToNextPage()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-md u-osb-md u-ost-md">
				<span>{{ 'Benu.Prescription_Purchase_Landing_Page.Go_To_Prescription_List' | translate }}</span>
			</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed  u-no-p u-ost-md c-text--center u-hidden@up-to-md">
			<button id="nextStepButton2" type="button" (click)="vm.redirectToNextPage()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-md u-osb-md u-osr-md">
				<span>{{ 'Benu.Prescription_Purchase_Landing_Page.Go_To_Prescription_List' | translate }}</span>
			</button>
		</div>
	</div>
</section>
